import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { LoadingService } from "../services/loading.service";
import { finalize } from "rxjs";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  loadingService = inject(LoadingService);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const skipLoading = req.headers.has('x-skip-loading');

    if (!skipLoading) {
      this.loadingService.show();
    }

    const modifiedReq = req.clone({
      headers: req.headers.delete('x-skip-loading'),
    });

    return next.handle(modifiedReq).pipe(
      finalize(() => {
        if (!skipLoading) {
          this.loadingService.hide();
        }
      })
    );
  }
}
